import {info} from "services-comun/modules/browser/log";

import { Auth } from "../../../services/auth";
import { IConfig } from "../../../config";
import { Ruta, IRuta } from "../../ruta";

export class AdminPublicidad extends Ruta {
    /* STATIC */
    public static build(config: IConfig, id: number): AdminPublicidad {
        return new this({
            id,
            ruta: `${config.router.basePath}/admin/publicidad/`,
        });
    }

    /* INSTANCE */
    public constructor(data: IRuta) {
        super(data);
    }

    public async check(path: string): Promise<void> {
        if (path!=this.data.ruta) {
            return Promise.reject("Admin/Publicidad: Rechazada");
        }
    }

    public async load(auth: Auth, config: IConfig, state?: any): Promise<void> {
        info("Cargando NavBar");
        const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../../componentes/navbar`);
        await NavBar.load(auth, config, state);
        info("Cargando Admin/Publicidad");
        const {AdminPublicidad} = await import(/* webpackChunkName: "admin-perfil" */ `../../../componentes/admin/publicidad`);
        await AdminPublicidad.load(auth, config, state);
    }

    public async unload(): Promise<void> {
        // info("Descargando NavBar");
        // const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../../componentes/navbar`);
        // await NavBar.unload();
        info("Descargando Admin/Publicidad");
        const {AdminPublicidad} = await import(/* webpackChunkName: "admin-perfil" */ `../../../componentes/admin/publicidad`);
        await AdminPublicidad.unload();
    }

    public async updateEstado(state?: any): Promise<void> {
        info("Actualizando el estado de NavBar");
        const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../../componentes/navbar`);
        await NavBar.updateEstado(state);
        info("Actualizando el estado de Admin/Perfil");
        const {AdminPublicidad} = await import(/* webpackChunkName: "admin-perfil" */ `../../../componentes/admin/publicidad`);
        await AdminPublicidad.updateEstado(state);
    }
}
